import '../App.css';
import React from "react";
import Nav from '../components/Nav.js';
import Hero from '../components/Hero.js';
import Marquee from '../components/Marquee.js';
import AppsTunnel from '../components/AppsTunnel.js';
import Studio from '../components/Studio.js';
import Contact from '../components/Contact.js';
import Footer from '../components/Footer.js';

const Home = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <AppsTunnel />
      <Studio />
      <Contact />
    </main>
    <Footer />
  </>
);

export default Home;
